import { Subtopic } from './subtopic.aggregate';

export const subtopicService = {
  createSubtopic: (subtopic: Subtopic): Subtopic => {
    return Object.freeze({
      id: subtopic.id,
      name: subtopic.name,
      nameLanguage: subtopic.nameLanguage,
      topicId: subtopic.topicId,
      topicName: subtopic.topicName,
      topicNameLanguage: subtopic.topicNameLanguage,
      descriptionLanguage: subtopic.descriptionLanguage,
      position: subtopic.position,
      survey: subtopic.survey,
      contents: subtopic.contents
    });
  }
};
